import CreditCardSpace from 'credit-card-space';

$('[data-widget="credit-card-number"]').each((index, _item) => {
  const original = $(_item);
  const replacement = $('<input type="text">');
  for (const attr of ['class', 'style', 'required']) {
    replacement.attr(attr, original.attr(attr));
  }
  replacement.attr('name', original.attr('name') + '_');
  replacement.val(original.val());
  original.attr('type', 'hidden');
  original.after(replacement);
  const ccSpace = new CreditCardSpace(replacement[0]);
  replacement.on('change keyup blur', e => {
    original.val(ccSpace.value());
  });
});